import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../shared/services/auth.service";
import {SaleService} from "../shared/services/sale.service";
 import {ConfirmPasswordValidator} from "../shared/classes/confirm-password.validator"
import {Subscription} from "rxjs";
 
import {NbToastrService, NbGlobalPosition, NbDialogService } from '@nebular/theme';
 

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss']
})
export class ProfilePageComponent implements OnInit, OnDestroy {

  form: FormGroup // = new FormGroup({})
  aSub:Subscription
  gSub:Subscription
  loading:boolean = false

  // Selling state, straight from the same gate the invoice uses - so what the
  // author reads here is what a buyer would actually run into.
  seller:any = null
  sellerLoading:boolean = true
  sellerSaving:boolean = false
  sellerError:string = ''
  sellerForm:any = {fop_name: '', tax_id: '', phone: '', contact_email: '',
    activity: '', shop_name: '', shop_url: '', logo_url: '', oferta: false}

  // The application is a form in its own right, so it opens as a dialog instead
  // of unfolding down a page someone came to for their password.
  @ViewChild('sellerModal') sellerModal: any

  constructor(

    public authService: AuthService, 
    private toastrService: NbToastrService,
    private formBuilder: FormBuilder,
    private dialogService: NbDialogService,
    private saleService: SaleService
  ) {
	}

  ngOnInit() {
  
  

 

    this.form =  this.formBuilder.group({
     // email: new FormControl(null, [Validators.required, Validators.email]),
       password: new FormControl(null, [Validators.required, Validators.minLength(6)]),
       new_password: new FormControl(null, [Validators.required, Validators.minLength(6)]),
	 rp_password: new FormControl(null, [Validators.required, Validators.minLength(6)])
  },{ validator: ConfirmPasswordValidator('new_password', 'rp_password')})

    this.loadSellerStatus()
  }

  loadSellerStatus(){
    this.sellerLoading = true
    this.saleService.getSellerStatus().subscribe((res)=>{
      this.sellerLoading = false
      if(!res || !res.ok){ return }
      this.seller = res
      this.sellerForm.fop_name = res.fop_name || ''
      this.sellerForm.tax_id = res.tax_id || ''
      this.sellerForm.phone = res.phone || ''
      // Starts as the cabinet login, which is right for most authors and easy to
      // change for the ones whose ФОП reads mail elsewhere.
      this.sellerForm.contact_email = res.contact_email || this.authService.userData?.login || ''
      // The bank's application also needs these. The server sends what the author
      // saved alongside what it would suggest from their channel; the suggestion
      // only ever fills a field that is empty, so it cannot overwrite an edit.
      const hint = res.suggested || {}
      this.sellerForm.activity = res.activity || hint.activity || ''
      this.sellerForm.shop_name = res.shop_name || hint.shop_name || ''
      this.sellerForm.shop_url = res.shop_url || hint.shop_url || ''
      this.sellerForm.logo_url = res.logo_url || hint.logo_url || ''
      // Pre-ticked only when this seller has already accepted the CURRENT wording.
      // Ticking it for any existing record meant a save re-stamped consent to a
      // revision they had never been shown.
      this.sellerForm.oferta = res.ofertaAccepted === true
    }, ()=>{ this.sellerLoading = false })
  }

  openSellerForm(){
    this.sellerError = ''
    this.dialogService.open(this.sellerModal, {hasScroll: true})
  }

  submitSellerRequest(ref?:any){
    this.sellerError = ''
    this.sellerSaving = true

    this.saleService.requestSellerOnboarding(this.sellerForm).subscribe((res)=>{
      this.sellerSaving = false
      if(!res || !res.ok){
        this.sellerError = (res && res.message) || 'Не вдалося зберегти заявку.'
        return
      }
      // Closed on success only: a refused application stays open with the reason
      // on it, because a dialog that vanishes takes the reason with it.
      if(ref){ ref.close() }
      this.toastrService.show('', res.message || 'Заявку прийнято.', {
        status: 'success',
        position: <NbGlobalPosition>'bottom-right'
      })
      this.loadSellerStatus()
    }, (err)=>{
      this.sellerSaving = false
      this.sellerError = err?.error?.message || 'Не вдалося зберегти заявку.'
    })
  }


  // The author's own state, said to the author.
  //
  // `seller.message` is the refusal the same gate hands a BUYER - "the author has
  // not connected payments" - and printing it in the author's own cabinet made
  // them read about themselves in the third person. The gate's machine `reason`
  // is what crosses the wire; each audience gets its wording where that audience
  // is served.
  get sellerHeading(): string {
    if(!this.seller){ return 'Приймання оплати не підключено' }
    if(this.seller.status === 'requested'){ return 'Банк підключає ваш ФОП' }
    if(this.seller.status === 'active'){ return 'Підключення завершується' }
    if(this.seller.status === 'suspended'){ return 'Приймання оплати призупинено' }
    if(this.seller.status === 'rejected'){ return 'Заявку відхилено' }
    return 'Приймання оплати не підключено'
  }

  get sellerCheckedAt(): string {
    if(!this.seller || this.seller.status !== 'requested' || !this.seller.bankCheckedAt){ return '' }
    const d = new Date(this.seller.bankCheckedAt)
    if(isNaN(d.getTime())){ return '' }
    const pad = (n:number)=> (n < 10 ? '0' : '') + n
    return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear() + ' о ' + pad(d.getHours()) + ':' + pad(d.getMinutes())
  }

  get sellerExplanation(): string {
    if(!this.seller){ return '' }

    switch(this.seller.reason){
      case 'trial_period_over':
        return 'Пробний період завершено. Щоб приймати оплату далі, оберіть тариф.'
      case 'gateway_not_configured':
        return 'Приймання оплати тимчасово недоступне з боку сервісу. Ми вже це виправляємо.'
      case 'seller_wrong_merchant':
        return 'Ваші реквізити треба підключити заново — ми вже цим займаємось і повідомимо вас.'
      case 'seller_not_active':
        if(this.seller.status === 'requested'){
          return 'Заявку передано до банку. Коли банк підготує підключення, у застосунку monobank вам надійде пуш із договором — підпишіть його. Після цього приймання оплати увімкнеться автоматично, ми надішлемо лист. Доти глядачі не зможуть оплатити ваш контент.'
        }
        if(this.seller.status === 'suspended'){
          return 'Приймання оплати для вашого акаунта призупинено. Напишіть нам — розберемось.'
        }
        if(this.seller.status === 'rejected'){
          return 'Заявку відхилено. Перевірте реквізити нижче й надішліть заявку ще раз.'
        }
        return 'Реквізити прийнято. Банк ще не завершив підключення — ми повідомимо, щойно оплата стане доступною. Поки що глядачі не зможуть оплатити ваш контент.'
      case 'seller_terminal_missing':
      case 'seller_receiver_missing':
        return 'Реквізити прийнято. Банк ще не завершив підключення — ми повідомимо, щойно оплата стане доступною. Поки що глядачі не зможуть оплатити ваш контент.'
    }

    return 'Поки приймання оплати не підключено, глядачі не можуть оплатити доступ до вашого контенту чи надіслати донат. Щоб підключити, заповніть заявку з реквізитами ФОП — далі ми передамо її до банку.'
  }


  ngOnDestroy(){
	    if(this.aSub){
	      this.aSub.unsubscribe()
	    }
	 if(this.gSub){
	      this.gSub.unsubscribe()
	    }
  }









	openCreatePasswordModal(content){
  
    this.dialogService.open(content,{hasScroll: true} )
	}


	generateNewPassword(ref){
		  ref.close()
		 if(this.gSub){
		      this.gSub.unsubscribe()
		    }

	this.loading = true
		 this.gSub = this.authService.generatePassword().subscribe((data: any)=>{
			 

			 this.toastrService.show('','Новий пароль відправлений на вашу пошту',{
			  status: 'success',
			position: <NbGlobalPosition>'bottom-right'
			})

		    },error => {
		      
		 
		 this.toastrService.show('',error.error ? error.error.message : error.message,{
			  status: 'warning',
			position: <NbGlobalPosition>'bottom-right'
			})

		    }, ()=>{this.loading = false})

		

	}


  submit() {
    if(this.form.invalid){
      return
    }

	 if(this.aSub){
      this.aSub.unsubscribe()
    }

    this.form.disable()
    this.aSub = this.authService.changePassword(this.form.value).subscribe((data: any)=>{
	this.form.reset()
 	this.form.enable()

	 this.toastrService.show('','Ви змінили пароль',{
          status: 'success',
	position: <NbGlobalPosition>'bottom-right'
        })

    },error => {
      this.form.enable()
 
 this.toastrService.show('',error.error ? error.error.message : error.message,{
          status: 'warning',
	position: <NbGlobalPosition>'bottom-right'
        })

    })
/**/

  }




}
